import type { Attachment } from "@/screens/app/threads/hooks/useEditorState"

// A url-less attachment persists as Content: "" and reaches the recipient as an empty link.
export function findUnsendableAttachment(
	attachments: Pick<Attachment, "url" | "state">[],
): "loading" | "missing-url" | null {
	if (attachments.some((a) => a.state === "loading")) return "loading"
	if (attachments.some((a) => !a.url)) return "missing-url"
	return null
}
